import { useState } from 'react';

export type Mode = 'view' | 'add' | 'edit';

export function usePWH205Mode() {
  const [mode, setMode] = useState<Mode>('view');

  const toView = () => setMode('view');
  const toAdd = () => setMode('add');
  const toEdit = () => setMode('edit');
  const isEditing = mode === 'add' || mode === 'edit';

  return { mode, toView, toAdd, toEdit, isEditing };
}
